"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "gotomap_cont" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_1, [
        _cache[2] || (_cache[2] = (0, vue_1.createTextVNode)("   ", -1)),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
            onClick: _cache[0] || (_cache[0] =
                (...args) => (_ctx.onclick && _ctx.onclick(...args)))
        }, [...(_cache[1] || (_cache[1] = [
                (0, vue_1.createTextVNode)("go to map", -1)
            ]))])), [
            [_directive_i18n]
        ])
    ]));
}
